import { render } from "./UpdateFormTickets.vue?vue&type=template&id=ff0213b4"
import script from "./UpdateFormTickets.vue?vue&type=script&lang=js"
export * from "./UpdateFormTickets.vue?vue&type=script&lang=js"

import "./UpdateFormTickets.vue?vue&type=style&index=0&id=ff0213b4&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__